export const documentMimeMap: Record<string, string> = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.odt': 'application/vnd.oasis.opendocument.text'
};
export const allowedDocumentExtensions = Object.keys(documentMimeMap).join(',');
export const allowedDocumentTypes = Object.values(documentMimeMap);

export const imageMimeMap: Record<string, string> = {
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.webp': 'image/webp',
  '.gif': 'image/gif'
};
export const allowedImageExtensions = Object.keys(imageMimeMap).join(',');
export const allowedImageTypes = Array.from(new Set(Object.values(imageMimeMap)));

export const fileSizeLimit = 5 * 1024 * 1024;
